import { FC } from "react";
import { Tabs } from "@rothoblaas/design-system";
import useI18n from "../../../../hooks/useTranslations";
import { ModuleSettings } from "../../../../http/types/modules";
import AdminFastenersTab from "./AdminFastenersTab";
import AdminMaterialGradesTab from "./AdminMaterialGradesTab";
import AdminLocksCatalogTab from "./catalog/CatalogAdminTabs";
import AdminReferenceTab from "./reference/ReferenceAdminTabs";

interface LockCalculatorAdminSettingsProps {
  moduleData: ModuleSettings;
}

const LockCalculatorAdminSettings: FC<LockCalculatorAdminSettingsProps> = () => {
  const i18n = useI18n();
  const t = i18n.translation;

  const tabs = [
    { title: t.lockCalculatorModule.admin.tabs.reference },
    { title: t.lockCalculatorModule.admin.fasteners.singular },
    { title: t.lockCalculatorModule.admin.materialGrades.singular },
    { title: t.lockCalculatorModule.admin.tabs.connectors },
  ];

  return (
    <Tabs renderMode="eager"
      urlParameter="l_tab"
      tabs={tabs}
      contents={[
        <AdminReferenceTab />,
        <AdminFastenersTab />,
        <AdminMaterialGradesTab />,
        <AdminLocksCatalogTab />,
      ]}
    />
  );
};

export default LockCalculatorAdminSettings;
